<template>
    <div class="card mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <button class="btn btn-success ml-2" @click="downloadCalendarData(3)">دانلود لیست مناسبت های کارمندان</button>
            <button class="btn btn-success" @click="downloadCalendarData(2)">دانلود لیست مناسبت های سازمان</button>
            <hr>
            <nav class="nav nav-tabs mb-3">
                <a class="nav-link ml-1 active" data-toggle="tab" href="#staff">مناسبت های کارمندان</a>
                <a class="nav-link" data-toggle="tab" href="#organization-tab">مناسبت های سازمان</a>
            </nav>
            <div class="tab-content">
                <div class="tab-pane fade active show" id="staff">
                    <form class="row" v-on:submit.prevent="submitExcelFile">
                        <div class="col-md-4">
                            <label>انتخاب فایل مناسبت ها</label>
                            <div class="input-group file-browser">
                                <input type="text" class="form-control border-left-0 browse-file" id="input-pan" placeholder="آپلود فایل" readonly="">
                                <label class="input-group-btn mb-0">
                                    <span class="btn btn-primary">
                                        انتخاب کنید <input type="file" style="display: none;" accept=".xlsx" @input="setExcelFile">
                                    </span>
                                </label>
                            </div>
                            <p class="mt-3 mb-0">
                                <a href="#" @click="e => getExcelSample(e)">دریافت فایل نمونه</a>
                            </p>
                        </div>
                        <div class="col-md-12">
                            <button class="btn btn-success mt-3 ml-2" v-if="file">ثبت اطلاعات</button>
                            <button class="btn btn-primary mt-3" v-if="resultFile" type="button" @click="getResultExcelFile">دریافت فایل نتیجه</button>
                        </div>
                    </form>
                </div>
                <div class="tab-pane fade" id="organization-tab">
                    <form class="row" v-on:submit.prevent="submitOccasion">
                        <div class="col-md-3">
                            <label>تاریخ</label>
                            <Datepicker simple auto-submit id="start-date" locale="fa" input-format="YYYY-MM-DD" v-model="date" :locale-config="{
                                fa: {
                                    displayFormat: 'jYYYY/jMM/jDD',
                                    lang: {label: 'شمسی'}
                                }
                            }" />
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>شرح مناسبت</label>
                                <input type="text" class="form-control" v-model="description">
                            </div>
                        </div>
                        <div class="col-md-4">
                            <button class="btn btn-success" style="margin-top: 29px" :disabled="!description.trim() || !description.trim().length">ثبت مناسبت</button>
                        </div>
                    </form>
                    <hr v-if="events.length">
                    <h5 class="mt-2 mb-4" v-if="events.length">مناسبت های روز {{ date.toString().replace(/-/g,'/') }}</h5>
                    <ul v-if="events.length" class="mb-0">
                        <li v-for="(event,index) in events" class="mb-2" :key="index">{{ event.title }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment-jalaali';
export default {
    name: 'Calendar',
    data(){
        return {
            showLoading: false,
            file: '',
            date: '',
            description: '',
            resultFile: '',
            events: []
        }
    },
    watch: {
        date(date){
            this.getDateEvents(date);
        }
    },
    methods: {
        getData(){
            this.$api.get('Organizations/Personnel').then(({data}) => {
                
            });
        },
        getResultExcelFile(){
            let csvString = this.resultFile;
            let universalBOM = '\uFEFF';
            let a = window.document.createElement('a');
            a.setAttribute('href','data:text/csv;charset=utf-8,' + encodeURIComponent(universalBOM + csvString));
            let fileName = 'personnel.csv';
            a.setAttribute('download',fileName);
            window.document.body.appendChild(a);
            a.click();
            window.document.body.removeChild(a);
        },
        getDateEvents(date){
            const postedData = {
                eventType: [
                    2
                ],
                fromDate: date.replace(/\//g,'-'),
                toDate: date.replace(/\//g,'-')
            };
            this.$api.post('Organizations/GetEvents',postedData).then(({data}) => {
                if(data.result.result && data.result.result.length){
                    this.events = data.result.result;
                }else
                    this.events = [];
            });
        },
        async toBase64(file){
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        async setExcelFile(e){
            const file = e.target.files[0];
            const finalFile = await this.toBase64(file);
            this.file = finalFile;
            this.resultFile = '';
            document.getElementById('input-pan').setAttribute('placeholder',file.name);
        },
        submitExcelFile(){
            this.showLoading = true;
            const postedData = {
                organizationId: 0,
                file: this.file
            };
            this.$api.post('Organizations/Personnel',postedData).then(({data}) => {
                this.resultFile = data.result ? data.result.file : '';
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'مناسبت ها با موفقیت بارگذاری شدند',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.file = '';
                    document.getElementById('input-pan').setAttribute('placeholder','آپلود فایل');
                }else
                    this.$swal({
                        title: 'خطا',
                        icon: 'error',
                        text: 'آپلود فایل ناموفق بود',
                        confirmButtonText: 'متوجه شدم'
                    });
            }).finally(() => {
                this.showLoading = false;
            });
        },
        submitOccasion(){
            this.showLoading = true;
            const postedData = {
                date: this.date.replace(/\//g,'-'),
                title: this.description
            };
            this.$api.post('Organizations/OrganizationEvent',postedData).then(({data}) => {
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'مناسبت جدید با موفقیت ایجاد شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.date = '';
                    this.description = '';
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        getExcelSample(e){
            e.preventDefault();
            this.$api.get('Organizations/Personnel/Sheet/Sample').then(({data}) => {
                let a = window.document.createElement('a');
                a.setAttribute('href','https://cardapi.sabinarya.com/api/v1/Lookup/download/' + data.result);
                let fileName = data.result;
                a.setAttribute('download',fileName);
                window.document.body.appendChild(a);
                a.click();
                window.document.body.removeChild(a);
            });
        },
        downloadCalendarData(type){
            let url = `Organizations/GetEvents/Sheet${type == 3 ? '/Personnel' : ''}?EventType=${type}`;
            this.$api.get(url).then(({data}) => {
                if(typeof data.result == 'string'){
                    let a = window.document.createElement('a');
                    a.setAttribute('href','https://cardapi.sabinarya.com/api/v1/Lookup/download/' + data.result);
                    let fileName = data.result;
                    a.setAttribute('download',fileName);
                    window.document.body.appendChild(a);
                    a.click();
                    window.document.body.removeChild(a);
                }else
                    this.$swal({
                        title: 'خطا',
                        icon: 'error',
                        text: 'تا کنون مناسبتی ثبت نکرده اید'
                    });
            });
        }
    },
    created(){
        this.getData();
        const date = new Date().toJSON().slice(0,10);
        let today = moment(date,'YYYY-MM-DD').format('jYYYY-jMM-jDD');
        this.date = today;
        this.getDateEvents(today);
    }
}
</script>